import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Wo1010GetResultModel, Wo1010GetResultSchema } from './get.schema'

export async function fetchWo1010(id: number): Promise<Wo1010GetResultModel> {
  const response = await axios.get<Wo1010GetResultModel>(
    `/api/production/wo1010/${id}`
  )
  return Wo1010GetResultSchema.parse(response.data)
}

export const getWo1010ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['wo1010', id],
    queryFn: () => fetchWo1010(id),
  })

export async function fetchWo1010ByNumber(
  number: string
): Promise<Wo1010GetResultModel> {
  const response = await axios.get<Wo1010GetResultModel>(
    `/api/production/wo1010/no/${number}`
  )
  return Wo1010GetResultSchema.parse(response.data)
}

export const getWo1010ByNumbeOptions = (number: string) =>
  queryOptions({
    queryKey: ['wo1010', number],
    queryFn: () => fetchWo1010ByNumber(number),
  })

export async function fetchWo1010ByLotNo(
  number: string
): Promise<Wo1010GetResultModel> {
  const response = await axios.get<Wo1010GetResultModel>(
    `/api/production/wo1010/lotno/${number}`
  )
  return Wo1010GetResultSchema.parse(response.data)
}

export const getWo1010ByLotNoOptions = (number: string) =>
  queryOptions({
    queryKey: ['wo1010', 'lotno', number],
    queryFn: () => fetchWo1010ByLotNo(number),
  })
